import { useAppSelector } from "../../hooks/redux-hooks";
import ClassicRecordCTA, { type RecordCTAProps } from "./ClassicRecordCTA.component";
import QuickStartCTA from "./QuickStartCTA.component";

/** The sidebar's Start card: Quick Start for accounts a pulled EHR schedule reaches, else the classic card. */
const RecordCTA = (props: RecordCTAProps) => {
  const quickStart = useAppSelector((state) => state.auth.userInfo.has_ehr_schedule === true);
  return quickStart ? <QuickStartCTA {...props} /> : <ClassicRecordCTA {...props} />;
};

export default RecordCTA;
